/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SelfCheckInKiosk {

    import ResponseStatus = Meevo.Model.ResponseStatus;
    import ISelfCheckInKioskSettingsModel = Meevo.Plugins.SelfCheckInKioskSettings.ISelfCheckInKioskSettingsModel;

    export class SelfCheckInKioskApi {

        static factory(): Function {
            const instance = (
                dataService: Meevo.Components.CommonClasses.ICommonDataService,
                identityService: Meevo.Components.Common.IIdentityService,
                appSettings: Meevo.Components.Common.IAppSettings
            ) => {
                return new SelfCheckInKioskApi(dataService, identityService, appSettings);
            };

            instance.$inject = [
                'meevo.components.common.DataService',
                'meevo.components.common.IdentityService',
                'meevo.AppSettings'
            ];

            return instance;
        }

        constructor(protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected appSettings: Meevo.Components.Common.IAppSettings) {
        }

        getCurrentTime(): ng.IPromise<{ locationId: number; locationTime: string; }> {
            return this.dataService
                .customMethodData(`${this.appSettings.API_ROOT}/TimeClock/LocationTime`, 'GET', null)
                .then(({ data }) => data);
        }

        getServiceEnhancements(serviceId: string, employeeId: string): ng.IPromise<IServiceAddOnsTemplateResponse> {
            return this.dataService.getListPaged('SelfCheckinKiosk/ServiceAddOnsTemplate', {
                pageNumber: 0,
                itemsPerPage: 20,
                sortDirection: 0,
                serviceId,
                employeeId,
                finalState: 2053,
                transitionState: 195
            });
        }

        getClientInfo({
                          phone,
                          countryCode,
                          email
                      }: { phone?: string; countryCode?: string; email?: string; }): ng.IPromise<IClientInfoResponseBody> {
            return this.dataService.customMethodData(`${this.appSettings.API_ROOT}/SelfCheckinKiosk/ClientInfo`, 'POST', {
                phone1: phone,
                countryCode: countryCode,
                email: email,
                isCheckinAppointmentSearch: false,
                firstName: '',
                lastName: ''
            }).then(({ data }) => data);
        }

        getAppointmentsList(clientId: string, lateCheckInMin: number): ng.IPromise<ISelfCheckinAppointment[]> {
            return this.getCurrentTime()
                .then((row) => {
                    return this.dataService.getListPaged(`${this.appSettings.API_ENDPOINTS.selfCheckInKiosk}/AppointmentServiceWithLocation`, {
                        locationId: this.identityService.current().locationId,
                        criteria: {
                            clientId,
                            startDate: moment(row.locationTime).add(lateCheckInMin * -1, 'minutes').format('YYYY-MM-DDTHH:mm:ss'),
                            endDate: moment(row.locationTime).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                            transitionStates: [Model.AppointStateEnum.Booked, Model.AppointStateEnum.NoShow, Model.AppointStateEnum.RunningLate],
                            finalStates: [Model.AppointFinalStateEnum.None],
                            localAppointmentsOnly: true,
                            includeAddons: true
                        }
                    });
                });
        }

        getSelfCheckinSettings(): ng.IPromise<ISelfCheckInKioskSettingsModel> {
            return this.dataService
                .customMethodData(`${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.selfCheckInKioskSettings}`, 'GET', null)
                .then(({ data }) => data);
        }

        checkinToAppointment(appointmentId: string, data: ICheckInRequestBody): ng.IPromise<void> {
            return this.dataService
                .customMethodData(
                    `${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.selfCheckInKiosk}/Checkin/${appointmentId}`,
                    'POST',
                    data
                ).then((res: ng.IHttpPromiseCallbackArg<{ responseStatus: ResponseStatus }>) => {
                    if (res.status !== 200) {
                        throw new Error(res.data.responseStatus.errors[0].message);
                    }
                });
        }

        getRegisterPriceList(services: IRegisterPriceRequest[]): ng.IPromise<IRegisterPriceResponse> {
            const request = {
                applySalePrograms: false,
                applyMemberDiscounts: true,
                applyYieldManagement: true,
                calculateCharges: true,
                services: services
            };

            return this.dataService
                .getListPaged(
                    `${this.appSettings.API_ENDPOINTS.selfCheckInKiosk}/Service/RegisterPrice`,
                    request
                );
        }

        getServiceWithPriorVisit(clientId: string, requestBody: { clientId: string; serviceIds: string[]; }): ng.IPromise<{ serviceId: string; }[]> {
            return this.dataService
                .getListPaged(
                    `${this.appSettings.API_ENDPOINTS.selfCheckInKiosk}/Client/${clientId}/ServiceWithPriorVisit`,
                    requestBody
                );
        }
    }


    angular.module('meevo.plugins.selfCheckInKiosk')
        .service('meevo.plugins.selfCheckInKiosk.SelfCheckInKioskApi', SelfCheckInKioskApi.factory());
}
